import { Vue, Component, Prop } from 'vue-property-decorator'
import SubportionDetailedIcon from '@/assets/images/svg/subportion-detailed-icon.vue'
import CommonSubportionStatusBadge from '@/components/common/CommonPortionStatusBadge.vue'

@Component({
    components: {
        SubportionDetailedIcon,
        CommonSubportionStatusBadge
    }
})
export default class GrossingTouchSubportionCard extends Vue {
    @Prop(Object) readonly subportionInfo!: object
}
